// extracted by mini-css-extract-plugin
export default {"whoTitle":"home_whoTitle__zFyUN","whoBtn":"home_whoBtn__hph2O"};